module.exports = __webpack_public_path__ + "static/free-9c639acd06b83877d964ecbb63e6ff1f.png";